import moment from "moment";
import { formatTimeRange } from "../utils/common";
import FavouriteIcon from "./FavouriteIcon";
import EventArtistsCaption from "./EventArtistsCaption";
import { Link } from "react-router-dom";
import useLocalStorage from "../hooks/useLocalStorage";
import { useState } from "react";
import { AttendEventForm, attendEventSchema } from "../routes/eventDetails";
import { usePost } from "../hooks/usePost";
import { toast } from "react-toastify";
import ImageWithSkeleton from "./ImageWithSkeleton";
import { getEventClub } from "../utils/eventClub";
import images from "../common/images";
import { getClubPath, getEventPath } from "../utils/clubPath";

const EventCard = ({ event, className = "" }) => {
  const club = getEventClub(event);
  const openRegisterEvent = (e) => {
    openModal();
  };
  const [modalIsOpen, setIsOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  function openModal() {
    setIsOpen(true);
  }
  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = '#f00';
  }

  function closeModal() {
    setIsOpen(false);
  }
  
  const images_list = Array.isArray(event?.images) && event?.images?.length ? event.images : [];
  const hasMultipleImages = images_list.length > 1;
  
  const handlePrevImage = (e) => {
    e.preventDefault();
    setCurrentImageIndex((prev) => (prev === 0 ? images_list.length - 1 : prev - 1));
  };
  
  const handleNextImage = (e) => {
    e.preventDefault();
    setCurrentImageIndex((prev) => (prev === images_list.length - 1 ? 0 : prev + 1));
  };
  
  const currentImage = images_list[currentImageIndex]?.path || images.background;
  
  const [isAttendent, setIsAttendent] = useLocalStorage(
    `attendance_${event._id}`,
    false,
  );
  const [formData, setFormData] = useState<Record<string, string>>({});
  const { mutate, isPending } = usePost({
    url: "/api/attend-event",
    onSuccess: (res) => {
      alert("Event attended successfully");
      // toast.success('Event attended successfully', {
      //   toastId: event._id
      // });
      // console.log('Event attended successfully', res);
      setIsAttendent(true);
      closeModal();
    },
    onError: (error) => {
      console.error("Error attending event:", error);
    },
  });
  const handleSubmit = (event) => {
    event.preventDefault();
    const result = attendEventSchema.safeParse({
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
    });
    if (!result.success) {
      toast.error("Name, email and mobile number are required");
      return;
    }
    mutate(new FormData(event.target));
  };
  function handlFieldChange(name) {
    return (ev) => {
      setFormData((prev) => {
        return { ...prev, [name]: ev.target.value };
      });
    };
  }
  return (
    <>
      <div
        className={"EventCard item wow fadeInUp " + className}
        data-wow-delay="0.3s"
      >
        <div className="card">
          <div className="date">
            <h2 className="date-text">
              {moment(event?.eventStartTime).format("DD")}
            </h2>
            <p className="date-month">
              {moment(event?.eventStartTime).format("MMM YYYY")}
            </p>
          </div>
          <FavouriteIcon
            endpoint={`api/user/likes/events/${event?._id}`}
            item={event}
            isLiked={!event?.meta?.isLiked}
          />
          <div>
            <div className="img-sec" style={{ position: 'relative' }}>
              <Link to={getEventPath(event)}>
                <ImageWithSkeleton
                  src={currentImage}
                  className="img-fluid"
                  alt="img"
                  skeletonHeight={220}
                />
              </Link>
              
              {hasMultipleImages && (
                <>
                  <button
                    onClick={handlePrevImage}
                    style={{
                      position: 'absolute',
                      left: '5px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      zIndex: 10,
                      background: 'rgba(0,0,0,0.5)',
                      border: 'none',
                      color: 'white',
                      width: '30px',
                      height: '30px',
                      borderRadius: '50%',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    ❮
                  </button>
                  <button
                    onClick={handleNextImage}
                    style={{
                      position: 'absolute',
                      right: '5px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      zIndex: 10,
                      background: 'rgba(0,0,0,0.5)',
                      border: 'none',
                      color: 'white',
                      width: '30px',
                      height: '30px',
                      borderRadius: '50%',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    ❯
                  </button>
                  <div
                    style={{
                      position: 'absolute',
                      bottom: '10px',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      background: 'rgba(0,0,0,0.6)',
                      color: 'white',
                      padding: '4px 12px',
                      borderRadius: '20px',
                      fontSize: '12px',
                      zIndex: 10
                    }}
                  >
                    {currentImageIndex + 1} / {images_list.length}
                  </div>
                </>
              )}
            </div>
            <div className="event-heading">
              <h4 className="">
                <Link
                  to={getEventPath(event)}
                  className="text-decoration-none "
                >
                  {event?.title}
                </Link>
              </h4>
              <EventArtistsCaption artists={event.artists} />
              <p className="p-20">
                {formatTimeRange(event?.eventStartTime, event?.eventEndTime)}
              </p>
              {event?.description ? (
                <p className="card__desc p-20">{event.description}</p>
              ) : (
                <p className="card__desc p-20 opacity-0" style={{ opacity: 0 }}>
                  {"-"}
                </p>
              )}
              <p className="card__addr p-20">
                <Link className="font-bold" to={getClubPath(club)}>
                  <strong
                    className="font-weight-bold"
                    style={{ fontFamily: "Axiforma" }}
                  >
                    {club?.name}{" "}
                     {[club?.locality || "", event?.address?.city || club?.city || ""]
                     .filter((e) => e)
                     .join(", ")}
                  </strong>
                </Link>
              </p>
              {event?.price?.amount ? (
                <p className="p-20">
                  {"₹" + event?.price?.amount + " Onwards"}
                </p>
              ) : null}
            </div>
          </div>
          {!isAttendent ? (
            <div className="mx-3 w-full mb-3">
              <button
                className="btn btn-dark btn-sm"
                type="button"
                onClick={openRegisterEvent}
                style={{ padding: "9px 15px 6px 15px" }}
              >
                Attend Event
              </button>
            </div>
          ) : null}
        </div>
      </div>
      <AttendEventForm
        {...{
          modalIsOpen,
          afterOpenModal,
          closeModal,
          handleSubmit,
          eventId: event._id,
          formData,
          handlFieldChange,
          isPending,
        }}
      />
    </>
  );
};

export default EventCard;
